import React from 'react';
import * as util from "../../../other/util.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";
import FleetStep from "./fleet-step.js";

export class PendingRaidFleetStep extends FleetStep {
    constructor() {
        super("RAID");
    }

    render(props, idx) {
        let duration = FleetFormulas.getTimeForRaid();

        return (
            <div>
                <p className="boring-info-text">Raiding</p>
                <span>
                    <span className="boring-info-text">Time: </span>
                    <util.NiceInlineTimeSpan timeSpan={duration} />
                </span>
            </div>);
    }
}

export class FixedRaidFleetStep extends FleetStep {
    render(props, idx) {
        let task = props.task;
        let step = task.steps[idx];

        if (this._isStepDone(props, idx)) {
            return this._renderDone("Raiding", idx);
        }

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (this.isStepActive(props, idx)) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <p className="boring-info-text">Raiding</p>
                <span>
                    <span className="boring-info-text">Time: </span>
                    {timer}
                </span>
            </div>);
    }
}